import React from 'react';
import './article.css';

const Article = ({ imgUrl, date, text, duration }) => (
  <div className="gpt3__blog-container_article">
    <div className="gpt3__blog-container_article-image">
      <img src={imgUrl} alt="blog_image" />
    </div>
    <div className="gpt3__blog-container_article-content">
      <div>
        <h1>{date}</h1>
        <h3>{text}</h3>
      </div>
      <p>{duration}</p>
    </div>
  </div>
);

export default Article;